<template>
    <div class="rounded-md bg-gray-50 px-6 py-5 sm:flex sm:items-start sm:justify-between">
        <div class="sm:flex sm:items-start">
            <div class="text-sm" v-if="clientsPayoutInvoiceBillTo.company_name">
                <label class="block text-sm mb-1.5 italic">Bill to</label>
                <input type="hidden" name="clients_payout_invoice_bill_to" v-model="clientsPayoutInvoiceBillToJson"/>
                <span class="font-semibold">{{ clientsPayoutInvoiceBillTo.company_name }}</span><br>
                {{ clientsPayoutInvoiceBillTo.address }}<br>
                {{ clientsPayoutInvoiceBillTo.zip ? clientsPayoutInvoiceBillTo.zip + ', ' : '' }}
                {{ clientsPayoutInvoiceBillTo.city ? clientsPayoutInvoiceBillTo.city + ', ' : ''}}
                {{ requireState ? clientsPayoutInvoiceBillTo.state + ', ' : '' }}
                {{ countryName }}
            </div>
            <div class="text-sm italic mt-2" v-else>Please provide your billing details for the invoice. Click Edit to enter your information.</div>
        </div>
        <div class="mt-4 sm:mt-0 sm:ml-6 sm:flex-shrink-0">
            <modal title="Billing details" size="large" name="payout-invoice-billing-info">
                <template #toggle>
                    <btn type="light">Edit</btn>
                </template>
                <template #body>
                    <validation-errors :errors="errors" class="mb-5" />
                    <div class="grid md:grid-cols-2 col-span-2 gap-8 gap-y-6">
                        <text-field
                            label="Company name"
                            field-id="company_name"
                            name="company_name"
                            type="text"
                            class="col-span-2"
                            :error="errors.company_name ?? false"
                            v-model="clientsPayoutInvoiceBillTo.company_name">
                        </text-field>
                        <text-field
                            label="Street address"
                            field-id="address"
                            name="address"
                            type="text"
                            :error="errors.address ?? false"
                            v-model="clientsPayoutInvoiceBillTo.address">
                        </text-field>
                        <text-field
                            label="City"
                            field-id="city"
                            name="city"
                            type="text"
                            :error="errors.city ?? false"
                            v-model="clientsPayoutInvoiceBillTo.city">
                        </text-field>

                        <div>
                            <field-label title="Country"/>
                            <select name="country" v-model="clientsPayoutInvoiceBillTo.country"
                                    class="block w-full rounded border-gray-300 sm:text-sm focus:ring-0 focus:border-gray-400">
                                <option v-for="country in countriesOptions" :value="country.value">
                                    {{ country.name }}
                                </option>
                            </select>
                        </div>

                        <text-field
                            label="ZIP / Postal"
                            field-id="zip"
                            name="zip"
                            type="text"
                            :error="errors.zip ?? false"
                            v-model="clientsPayoutInvoiceBillTo.zip">
                        </text-field>
                        <text-field
                            v-if="requireState"
                            label="State / Province"
                            field-id="state"
                            name="state"
                            type="text"
                            :error="errors.state ?? false"
                            v-model="clientsPayoutInvoiceBillTo.state">
                        </text-field>
                    </div>

                </template>
                <template #footer>
                    <btn :loading="loading.update" @click="update">Save</btn>
                </template>
            </modal>
        </div>
    </div>
</template>
<script>

import ValidationErrors from "../../../../common/ValidationErrors.vue";

export default {
    name: "PayoutInvoiceBillingInformation",
    components: {ValidationErrors},

    props: {
        formErrors: {},
        program: {
            type: Object,
            required: true,
        },
        billingInformation: {type: Object, required: false},

        countries: {
            type: Array,
            required: true,
        },
        countriesRequiringState: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            errors: {},
            clientsPayoutInvoiceBillTo: {
                country: this.billingInformation.country ?? null,
                company_name: this.billingInformation.company_name ?? null,
                address: this.billingInformation.address ?? null,
                city: this.billingInformation.city ?? null,
                zip: this.billingInformation.zip ?? null,
                state: this.billingInformation.state ?? null,
            },
            loading: {
                update: false,
            }
        }
    },
    methods: {
        update() {

            if (this.loading.update === true) {
                return;
            }

            this.errors = {};
            this.loading.update = true;

            axios.post(route('app_int.update_payout_invoice_billing_information', this.program),
                {
                    clients_payout_invoice_bill_to: this.clientsPayoutInvoiceBillToJson,
                    ...this.clientsPayoutInvoiceBillTo
                }
            )
                .then((response) => {
                    const status = parseInt(response.data.status ?? -1);
                    if (status === 1) {
                        this.emitter.emit('modal-off', 'payout-invoice-billing-info')
                    }
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                })
                .finally(() => this.loading.update = false);
        }
    },
    computed: {
        countryName() {
            const code = this.clientsPayoutInvoiceBillTo.country;
            const country = this.countries.find((i) => {
                return i.value === code;
            });

            if (country) {
                return country.name;
            }

            return '';
        },
        countriesOptions() {
            return this.countries.map((i) => ({
                name: i.name,
                value: i.value,
            }));
        },
        requireState() {
            return this.countriesRequiringState.includes(this.clientsPayoutInvoiceBillTo.country)
        },
        clientsPayoutInvoiceBillToJson() {
            return JSON.stringify(this.clientsPayoutInvoiceBillTo)
        },
    },
}
</script>

